<template>
  <div class="order-detail-container">
    <el-card class="order-card">
      <div class="page-header">
        <h2>邮寄样品</h2>
        <el-button @click="$router.back()">返回</el-button>
      </div>
      
      <el-form ref="orderForm" :model="orderForm" label-width="120px" label-position="right">
        <el-divider content-position="left">
          <span class="divider-title">项目信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="项目名称">
              <el-input v-model="orderForm.projectName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称">
              <el-input v-model="orderForm.customer" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="联系人">
              <el-input v-model="orderForm.contact" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式">
              <el-input v-model="orderForm.phone" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="地址">
              <el-input v-model="orderForm.address" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="样品数量">
              <el-input v-model="orderForm.sampleCount" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="预期完成时间">
              <el-input v-model="orderForm.expectedCompletionDate" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单状态">
              <el-tag :type="getStatusType(orderForm.status)" style="width: 100%; text-align: center;">{{ orderForm.status }}</el-tag>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input type="textarea" v-model="orderForm.remark" :rows="3" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">
          <span class="divider-title">商家信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="商家名称">
              <el-input v-model="orderForm.merchant" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="仪器信息">
              <el-input v-model="orderForm.equipment" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仪器型号">
              <el-input v-model="orderForm.equipmentModel" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24" v-if="!isCustomerView">
          <el-col :span="12">
            <el-form-item label="参考价格">
              <el-input v-model="orderForm.referencePrice" disabled>
                <template slot="prepend">¥</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实际价格">
              <el-input v-model="orderForm.actualPrice" disabled>
                <template slot="prepend">¥</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="联系人">
              <el-input v-model="orderForm.merchantContact" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式">
              <el-input v-model="orderForm.merchantPhone" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="地址">
              <el-input v-model="orderForm.merchantAddress" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">
          <span class="divider-title">测试要求附件</span>
        </el-divider>
        
        <div class="file-list-container" v-if="fileList.length > 0">
          <h3 class="file-list-title">附件列表</h3>
          <el-table
            :data="fileList"
            style="width: 100%"
            border>
            <el-table-column
              prop="name"
              label="文件名"
              min-width="300">
            </el-table-column>
            <el-table-column
              prop="size"
              label="大小"
              width="150">
              <template slot-scope="scope">
                {{ formatFileSize(scope.row.size) }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="150"
              align="center">
              <template slot-scope="scope">
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handlePreview(scope.row)">预览</el-button>
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handleDownload(scope.row)" 
                  style="margin-left: 10px;">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else class="no-file">
          <el-empty description="暂无附件"></el-empty>
        </div>

        <el-divider content-position="left">
          <span class="divider-title">物流信息</span>
        </el-divider>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="物流公司" required>
              <el-select v-model="shipForm.company" placeholder="请选择物流公司" style="width: 100%">
                <el-option
                  v-for="item in logisticsOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="快递单号" required>
              <el-input v-model="shipForm.trackingNo" placeholder="请输入快递单号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="邮寄时间" required>
              <el-date-picker
                v-model="shipForm.shipTime"
                type="datetime"
                placeholder="选择邮寄时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="form-footer">
          <el-button type="primary" @click="handleSubmit">确认邮寄</el-button>
          <el-button @click="$router.back()">取消</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'ShipOrder',
  data() {
    return {
      orderForm: {
        projectName: '',
        customer: '',
        contact: '',
        phone: '',
        address: '',
        sampleCount: 1,
        expectedCompletionDate: '',
        remark: '',
        merchant: '',
        equipment: '',
        equipmentModel: '',
        merchantContact: '',
        merchantPhone: '',
        merchantAddress: '',
        referencePrice: '',
        actualPrice: '',
        status: '未邮寄'
      },
      shipForm: {
        company: '',
        trackingNo: '',
        shipTime: ''
      },
      logisticsOptions: [],
      fileList: [],
      isCustomerView: false
    }
  },
  created() {
    const orderId = this.$route.params.id
    if (orderId) {
      this.fetchOrderDetail(orderId)
    } else {
      this.$message.error('订单ID不存在')
      this.$router.push('/admin/orders/not-shipped')
    }
    
    // 获取物流公司列表
    this.fetchLogisticsList()
    
    // 设置默认邮寄时间为当前时间
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    
    this.shipForm.shipTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    // 检查当前路径，判断是否是客户端访问
    this.isCustomerView = this.$route.path.includes('/customer/');
  },
  methods: {
    async fetchOrderDetail(id) {
      try {
        this.$loading({
          lock: true,
          text: '加载订单信息...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        
        const orderData = await adminApi.getOrderById(id)
        console.log('获取到的订单数据:', orderData)
        
        if (orderData) {
          // 根据API返回数据映射到表单字段
          this.orderForm = {
            projectName: orderData.projectName || '',
            customer: orderData.customerName || '',
            contact: orderData.customerPerson || '',
            phone: orderData.customerPhone || '',
            address: orderData.customerAddress || '',
            sampleCount: orderData.testCount || 1,
            expectedCompletionDate: orderData.expectedEndTime || '',
            remark: orderData.remarks || '',
            merchant: orderData.merchantName || '',
            equipment: orderData.deviceName || '',
            equipmentModel: orderData.deviceModel || '',
            merchantContact: orderData.merchantPerson || '',
            merchantPhone: orderData.merchantPhone || '',
            merchantAddress: orderData.merchantAddress || '',
            referencePrice: orderData.guidePrice || '',
            actualPrice: orderData.actualPrice || '',
            status: this.mapOrderStatus(orderData.orderStatus) || '未邮寄'
          }
          
          // 如果有附件数据，设置文件列表
          if (orderData.orderFile && orderData.orderFile.length > 0) {
            console.log('原始附件数据:', orderData.orderFile)
            
            this.fileList = orderData.orderFile.map(file => {
              // 优先使用fileUrl字段，如果没有则尝试url字段
              const fileUrl = file.fileUrl || file.url || ''
              console.log(`文件 ${file.fileName || '未命名'} 的URL:`, fileUrl)
              
              return {
                name: file.fileName || '未命名文件',
                size: file.fileSize || 0,
                uploadTime: file.uploadTime || new Date(),
                url: fileUrl,
                status: 'success'
              }
            })
            
            console.log('处理后的文件列表:', this.fileList)
          }
        }
      } catch (error) {
        this.$message.error('获取订单信息失败：' + (error.message || '未知错误'))
        console.error('获取订单失败:', error)
      } finally {
        this.$loading().close()
      }
    },
    
    // 订单状态映射
    mapOrderStatus(status) {
      const statusMap = {
        'NOT_SHIPPED': '未邮寄',
        'SHIPPED': '已邮寄',
        'TESTING': '测试中',
        'COMPLETED': '已完成',
        'CANCELED': '已取消'
      }
      return statusMap[status] || status
    },

    getStatusType(status) {
      const typeMap = {
        '未邮寄': 'info',
        '已邮寄': 'warning',
        '测试中': 'primary',
        '已完成': 'success',
        '已取消': 'danger'
      }
      return typeMap[status] || 'info'
    },
    handlePreview(file) {
      // 调用统一的预览方法
      adminApi.previewFile(file, this.$message)
        .catch(error => {
          console.error('文件预览失败:', error);
        });
    },
    
    handleDownload(file) {
      // 调用统一的下载方法
      adminApi.downloadFileUnified(file, this.$message)
        .catch(error => {
          console.error('文件下载失败:', error);
        });
    },
    
    formatFileSize(size) {
      if (!size) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB']
      let index = 0
      while (size >= 1024 && index < units.length - 1) {
        size /= 1024
        index++
      }
      return size.toFixed(2) + ' ' + units[index]
    },
    handleSubmit() {
      if (!this.shipForm.company) {
        this.$message({
          message: '请选择物流公司',
          type: 'warning'
        })
        return
      }
      
      if (!this.shipForm.trackingNo) {
        this.$message({
          message: '请输入快递单号',
          type: 'warning'
        })
        return
      }

      if (!this.shipForm.shipTime) {
        this.$message({
          message: '请选择邮寄时间',
          type: 'warning'
        })
        return
      }

      // 提交邮寄信息
      this.updateOrderShipInfo()
    },

    async updateOrderShipInfo() {
      try {
        this.$loading({
          lock: true,
          text: '提交邮寄信息...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 构建提交的数据
        const orderData = {
          id: this.$route.params.id,
          trackName: this.shipForm.company,
          trackSn: this.shipForm.trackingNo,
          trackTime: this.shipForm.shipTime,
          orderStatus: 'IN_TRANSIT'
        }

        console.log('提交的物流信息:', orderData);

        // 使用真实API调用
        await adminApi.editOrder(orderData);
        
        this.$loading().close();
        this.$message({
          message: '邮寄信息提交成功',
          type: 'success'
        });
        
        // 获取当前路径前缀，决定跳转路径
        const currentPath = window.location.pathname;
        let redirectPath = '/admin/orders/in-transit';
        
        if (currentPath.startsWith('/customer')) {
          redirectPath = '/customer/orders/in-transit';
          console.log('检测到客户端路径，跳转到:', redirectPath);
        } else if (currentPath.startsWith('/merchant')) {
          redirectPath = '/merchant/orders/in-transit';
          console.log('检测到商家端路径，跳转到:', redirectPath);
        } else {
          console.log('检测到管理端路径，跳转到:', redirectPath);
        }
        
        this.$router.push(redirectPath);
      } catch (error) {
        this.$loading().close()
        this.$message.error('提交邮寄信息失败：' + (error.message || '未知错误'))
        console.error('提交邮寄信息失败:', error)
      }
    },

    async fetchLogisticsList() {
      try {
        const res = await adminApi.getLogisticsList()
        if (res && Array.isArray(res)) {
          // 转换为select需要的格式
          this.logisticsOptions = res.map(item => ({
            value: item.trackCode,
            label: item.trackName
          }))
        } else {
          this.$message.warning('获取物流公司列表失败')
        }
      } catch (error) {
        console.error('获取物流公司列表错误:', error)
        this.$message.error('获取物流公司列表失败: ' + (error.message || '未知错误'))
      }
    }
  }
}
</script>

<style scoped>
.order-detail-container {
  padding: 30px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.order-card {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.page-header h2 {
  margin: 0;
  color: #303133;
  font-size: 24px;
}

.divider-title {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
  position: relative;
  padding-left: 12px;
}

.divider-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 18px;
  width: 4px;
  background-color: #409EFF;
  border-radius: 2px;
}

.el-form-item {
  margin-bottom: 24px;
}

.el-form-item__label {
  font-weight: bold;
  color: #606266;
  white-space: nowrap;
  padding-right: 10px;
}

.file-list-container {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.file-list-title {
  margin: 0 0 20px 0;
  font-size: 16px;
  color: #303133;
  position: relative;
  padding-left: 12px;
  border-left: 3px solid #409EFF;
}

.no-file {
  padding: 40px 0;
}

.form-footer {
  margin-top: 40px;
  text-align: center;
}

.form-footer .el-button {
  min-width: 120px;
  margin: 0 10px;
}
</style> 